// Client de api.php : JSON, gzip au-delà de 200 Ko, keepalive, un réessai en lecture, repli hors ligne.
import { consommerLabel } from './undo.js';

window.syncWithServer = function(action, payload, callback, opts) {
    var s = window.state;
    var planningId = (payload && payload.planning_id) || s.currentPlanningId || 'default';

    if (action === 'save_tasks' && s.planningIndisponible && planningId === s.currentPlanningId) {
        // Le planning n'a pas pu être lu au démarrage (serveur injoignable, JSON illisible, PHP à court de mémoire…) :
        // l'écran est vide, mais le serveur, lui, détient peut-être des milliers de séances. Enregistrer maintenant les
        // écraserait. On refuse, on le dit, et l'écran ne fait pas comme si c'était fait.
        consommerLabel();
        window.messageServeur('Enregistrement bloqué : le planning n\'a pas pu être chargé (' + s.planningIndisponible + '). Recharge la page avant de le modifier.', true);
        if (callback) callback({ success: false, bloque: true, message: s.planningIndisponible });
        return;
    }
    if (action === 'save_tasks') {
        // L'état déjà enregistré devient le point de retour de « Revenir en arrière », mais seulement si
        // l'action s'est déclarée (window.planningAction) : sinon c'est un enregistrement technique.
        var libelle = consommerLabel();
        if (libelle) window.undoPush(planningId, window.planningRef(planningId), libelle);
        if (planningId === s.currentPlanningId) { s.tasks = payload.tasks; }
        window.setPlanningRef(planningId, JSON.stringify(payload.tasks));
    }
    if (action === 'login' || action === 'register') {
        localStorage.setItem('edn_logged_in', 'true');
    }
    if (action === 'logout') {
        localStorage.removeItem('edn_logged_in');
    }

    var bodyObj = Object.assign({ action: action, planning_id: planningId }, payload || {});
    var corps = JSON.stringify(bodyObj);
    // keepalive : la requête survit au déchargement de la page (limite du navigateur : 64 Ko)
    var options = { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: corps };
    if (opts && opts.keepalive && corps.length < 60000) options.keepalive = true;
    // Un gros envoi (un planning de plusieurs Mo) part compressé : du JSON aussi répétitif se réduit dix fois, ce
    // qui compte sur un téléphone en 4G — et ce qui faisait dépasser le plafond du serveur. Le navigateur sait
    // compresser depuis Safari 16.4 et Chrome 80 ; sans cela, le corps part tel quel. L'en-tête est à nous : le
    // serveur web ne doit pas croire qu'il a quelque chose à décoder lui-même.
    var preparer = function() {
        if (corps.length < 200000 || !window.CompressionStream || options.keepalive) return Promise.resolve(options);
        try {
            var flux = new Blob([corps]).stream().pipeThrough(new CompressionStream('gzip'));
            return new Response(flux).blob().then(function(b) {
                var o = Object.assign({}, options, { body: b, headers: Object.assign({}, options.headers, { 'X-EDN-Encodage': 'gzip' }) });
                window.__dernierEnvoi = { action: action, brut: corps.length, envoye: b.size };
                return o;
            }).catch(function() { return options; });
        } catch (e) { return Promise.resolve(options); }
    };
    // Une requête interrompue parce qu'on quitte la page n'est pas une panne : on ne la compte pas.
    var tentative = 0;
    var lancer = function() { return preparer().then(function(o) { return fetch('api.php', o); }); };
    var reessai = function(e) {
        // Un seul nouvel essai, pour une lecture seulement, après un court délai : un accroc réseau d'une seconde ne
        // doit pas faire passer le site « hors ligne » alors qu'il ne l'est pas.
        if (window.__quitte) return new Promise(function() {});   // la page s'en va : on ne conclut rien
        if (tentative++ < 1 && window.ACTIONS_LECTURE.test(action)) return new Promise(function(r) { setTimeout(r, 700); }).then(lancer);
        throw e;
    };
    lancer().catch(reessai)
    .then(function(res) {
        // Le serveur répond en JSON MÊME quand il refuse (401 pas connecté, 403 pas le droit, 413 envoi trop
        // lourd…). Sa réponse explique ce qui s'est passé : on la lit toujours. Basculer en « injoignable » sur un
        // code d'erreur revenait à jeter l'explication et à accuser le réseau — c'est ce qui affichait « Serveur
        // injoignable » quand un extrait de voix dépassait la taille acceptée.
        return res.text().then(function(t) { return { texte: t, status: res.status }; });
    })
    .then(function(r) {
        var text = r.texte, data;
        try { data = JSON.parse(text); } catch(e) { throw new Error("Réponse serveur non valide (HTTP " + r.status + ") : " + String(text || '').replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim().slice(0, 200)); }

        // Base de données injoignable : le serveur répond bien (HTTP 200) mais ne peut rien lire ni écrire.
        // On repasse sur les données locales comme lors d'une coupure réseau, au lieu d'une erreur brute.
        if (data && data.db_down) { fallbackLocal(); return; }

        s.serverStatus = 'online';
        // Un enregistrement d'état (planning, préférences, apprentissage) que le serveur REFUSE ne doit jamais passer
        // inaperçu : l'écran montre déjà la modification, l'utilisateur croirait qu'elle est gardée. On le dit, avec
        // le motif du serveur ; et pour le planning, on remet l'écran à ce que le serveur détient vraiment.
        if (data && data.success === false && window.ACTIONS_ETAT.test(action) && data.logged_in !== false && !data.relogin) {
            window.messageServeur('Non enregistré — ' + (data.message || 'le serveur a refusé'), true);
            if (action === 'save_tasks' && !window.__rechargeTachesEnCours) {
                window.__rechargeTachesEnCours = true;
                window.syncWithServer('get_tasks', { planning_id: planningId }, function(d) {
                    window.__rechargeTachesEnCours = false;
                    if (d && d.success && Array.isArray(d.tasks) && planningId === s.currentPlanningId) { s.tasks = window.assainirTaches(d.tasks); window.setPlanningRef(planningId, JSON.stringify(s.tasks)); window.renderContent(); }
                });
            }
        }
        // Le planning lu sur le serveur devient la copie locale de référence : c'est elle qui sert de point
        // de retour à la première action « Revenir en arrière » de la session.
        if (action === 'get_tasks' && data && Array.isArray(data.tasks)) window.setPlanningRef(planningId, JSON.stringify(data.tasks));
        window.renderHeader();
        // Une erreur de programmation dans le traitement de la réponse (un rendu qui plante au démarrage, par
        // exemple) n'est PAS une panne réseau : passée au .catch ci-dessous, elle rejouait le repli « serveur
        // injoignable », replantait dedans, et la page restait blanche sans un mot. Elle est signalée pour ce
        // qu'elle est, dans le cadre rouge, avec sa ligne.
        if(callback) { try { callback(data); } catch (e) { window.signalerErreur(e, action); } }
    })
    .catch(fallbackLocal);

    // Serveur injoignable (réseau coupé, base de données arrêtée). Il n'y a plus de copie locale : le planning ne
    // peut être ni lu ni enregistré. On garde ce qui est déjà à l'écran, on le dit une fois, clairement.
    function fallbackLocal() {
        s.serverStatus = 'offline';
        window.renderHeader();
        if(action === 'get_tasks') {
            if(callback) callback({ logged_in: localStorage.getItem('edn_logged_in') === 'true', tasks: s.tasks || [], offline: true });
        } else if(action === 'list_plannings') {
            if(callback) callback({ success: true, plannings: window.loadPlanningsMetaLocal(), offline: true });
        } else if(action === 'login' || action === 'register') {
            if(callback) callback({ success: false, offline: true, message: 'Serveur injoignable pour le moment : réessaie dans un instant.' });
        } else {
            if (!window.ACTIONS_LECTURE.test(action)) window.messageServeur('Serveur injoignable : cette modification n\'a pas pu être enregistrée.');
            if(callback) callback({ success: true, offline: true });
        }
    }
};

// Actions qui ne modifient rien : leur échec ne mérite pas d'avertissement, la page se contente d'attendre.
window.ACTIONS_LECTURE = /^(get_|list_|me$|qcm_index|batch_list|abonnement_info|podcast_index|fiche_structure|chrono_index|lca_cours|ai_status|qcm_ai_list|qcm_override_list)/;
// Les enregistrements de l'état du site : personne d'autre ne rend compte de leur échec, syncWithServer le fait.
window.ACTIONS_ETAT = /^(save_tasks|save_prefs|save_learning|create_planning|rename_planning|delete_planning)$/;
window.messageServeur = function(txt, important) {
    if (!important && Date.now() - (window.__dernierMessageServeur || 0) < 5000) return; // un seul avertissement par salve d'appels
    window.__dernierMessageServeur = Date.now();
    if (window.undoMessage) window.undoMessage(txt);
};

// Exports : les mêmes fonctions que celles posées sur window (le code historique les lit encore là).
export const syncWithServer = window.syncWithServer;
export const ACTIONS_LECTURE = window.ACTIONS_LECTURE;
export const ACTIONS_ETAT = window.ACTIONS_ETAT;
export const messageServeur = window.messageServeur;
